<template>
  <i
    class="o-icon o-icon--resume"
    @click="replay"
  ></i>
</template>
<script>
  import { EmbeddedRouteName, ProductType } from '@/shared/enums';

  export default {
    name: 'UiPlayerReplay',
    inject: ['embeddedReplayProduct'],
    computed: {
      product() {
        return this.embeddedReplayProduct;
      },
    },
    methods: {
      replay() {
        this.$router.replace({
          name: EmbeddedRouteName.PLAYER,
          params: {
            slug: this.product.slug || '',
            type: this.product.type || ProductType.VOD,
            id: this.product.id || 0,
          },
          query: this.$route.query,
        });
      },
    },
  };
</script>
